import { createPinia } from "pinia"
import { createPersistedState } from "pinia-plugin-persistedstate"

export const pinia = createPinia()

// Configure persistence plugin
pinia.use(
  createPersistedState({
    key: (storeKey) => `pinia-${storeKey}`,
    storage: localStorage,
  }),
)

export default pinia
